export default __webpack_public_path__ + "static/media/testimonio1.42de3858.png";